import { AdminCollectionEditor } from '../../_Shared/_UI/AdminCollectionEditor';
import { AdminSingletonEditor } from '../../_Shared/_UI/AdminSingletonEditor';
import { AdminViewLayout } from '../../_Shared/_UI/AdminViewLayout';
import { ADMIN_DEFAULT_ORDER, ADMIN_VISIBILITY_FILTER } from '../../_Shared/_Config/AdminCollectionFilters';
import { PROFILE_ADMIN_API as API } from '../_MODULES/_API';
import '../../_Shared/_UI/_Styles/PortfolioAdmin.css';

const PROFILE_FIELDS = [
    { name: 'photo', label: 'Foto de perfil', type: 'image', span: 2 },
    { name: 'name', label: 'Nombre' }, { name: 'brand', label: 'Marca / nombre corto' },
    { name: 'role', label: 'Rol profesional' }, { name: 'badge', label: 'Badge del hero' },
    { name: 'hero_title', label: 'Titulo hero (acepta <em>)', span: 2 },
    { name: 'hero_subtitle', label: 'Subtitulo / presentacion', type: 'textarea', rows: 3, span: 2 },
    { name: 'location', label: 'Ubicacion' }, { name: 'website', label: 'Sitio web' },
    { name: 'languages', label: 'Idiomas' }, { name: 'availability', label: 'Disponibilidad' },
    { name: 'footer_text', label: 'Texto de footer', span: 2 },
];

const ABOUT_FIELDS = [
    { name: 'paragraph_1', label: 'Primer parrafo', type: 'textarea', rows: 5, span: 2 },
    { name: 'paragraph_2', label: 'Segundo parrafo', type: 'textarea', rows: 5, span: 2 },
    { name: 'badges', label: 'Badges separados por coma', type: 'tags', span: 2 },
];

export const ProfileViewMain = () => (
    <AdminViewLayout
        pageKey="profile"
        title="Perfil y acerca de mi"
        description="Edita la tarjeta principal, fotografia, datos personales, presentacion, estadisticas y stack sin tocar codigo."
    >
        <AdminSingletonEditor title="Perfil publico" description="Datos que aparecen en el hero y la tarjeta personal." getEndpoint={API.PROFILE_GET} saveEndpoint={API.PROFILE_SAVE} fields={PROFILE_FIELDS} />
        <AdminSingletonEditor title="Acerca de mi" description="Contenido editorial de la seccion sobre mi." getEndpoint={API.ABOUT_GET} saveEndpoint={API.ABOUT_SAVE} fields={ABOUT_FIELDS} />
        <AdminCollectionEditor
            title="Estadisticas"
            description="Anios, proyectos, clientes o cualquier metrica destacada."
            listEndpoint={API.STATS_LIST}
            saveEndpoint={API.STATS_SAVE}
            removeEndpoint={API.STATS_REMOVE}
            titleField="label"
            subtitleField="value"
            searchFields={['label', 'value']}
            filters={[ADMIN_VISIBILITY_FILTER]}
            orderOptions={ADMIN_DEFAULT_ORDER('label')}
            fields={[
                { name: 'value', label: 'Valor' }, { name: 'label', label: 'Etiqueta' }, { name: 'sort_order', label: 'Orden', type: 'number', defaultValue: 0 }, { name: 'active', label: 'Visible', type: 'checkbox', defaultValue: true },
            ]}
        />
        <AdminCollectionEditor
            title="Stack / especialidades"
            description="Tarjetas de tecnologias y capacidades."
            listEndpoint={API.SKILLS_LIST}
            saveEndpoint={API.SKILLS_SAVE}
            removeEndpoint={API.SKILLS_REMOVE}
            titleField="title"
            subtitleField="items"
            searchFields={['title', 'items']}
            filters={[ADMIN_VISIBILITY_FILTER, {
                key: 'items_filter',
                field: 'items',
                label: 'Tecnologias',
                type: 'multi',
                tokenize: true,
                matchMode: 'any',
                placeholder: 'Seleccionar tecnologias…',
            }]}
            orderOptions={ADMIN_DEFAULT_ORDER('title')}
            fields={[
                { name: 'title', label: 'Titulo' }, { name: 'items', label: 'Tecnologias / descripcion' }, { name: 'sort_order', label: 'Orden', type: 'number', defaultValue: 0 }, { name: 'active', label: 'Visible', type: 'checkbox', defaultValue: true },
            ]}
        />
    </AdminViewLayout>
);
